import { getConfigByLocale } from "config/global";
import { COACHING_STYLE, COACHING_STYLE_SECOND, NEXT_COACH } from "config/tags";
import { checkIsPremium } from "utils/resultFunctions/guidedSelling";
import { isPremiumOrCoaching } from "utils/resultFunctions/guidedSellingAU";
import { isUserOnDiabetesBranch } from "utils/uniBranching";

export const getCoachPreferenceUrlPath = ({
  question,
  answers,
  assessment,
  routes,
  newQuiz
}) => {
  if (question.tags.includes(NEXT_COACH)) {
    const showCoachesFuncName = getConfigByLocale(window.ww.locale)[
      "doShowCoachQuestionFuncName"
    ];

    const checkIfShowCoachesQuestion = {
      checkIsPremium,
      isPremiumOrCoaching
    };

    const showCoachesQuestion = checkIfShowCoachesQuestion[showCoachesFuncName](
      answers,
      assessment.questions
    );

    if (showCoachesQuestion) {
      return routes.question(
        assessment.questions.find(q =>
          q.tags.includes(
            newQuiz.isUni2 &&
              isUserOnDiabetesBranch(answers, assessment.questions)
              ? COACHING_STYLE_SECOND
              : COACHING_STYLE
          )
        ).urlPath
      );
    }
  }

  return null;
};

export const coachRouting = ({
  nextUrlPath: nextUrlPathInit,
  question,
  answers,
  assessment,
  routes,
  newQuiz
}) => {
  let nextUrlPath = nextUrlPathInit;

  const coachPreferenceUrlPath = getCoachPreferenceUrlPath({
    assessment,
    question,
    answers,
    routes,
    newQuiz
  });

  if (coachPreferenceUrlPath) {
    nextUrlPath = coachPreferenceUrlPath;
  }

  return nextUrlPath;
};
